import type { BossDefinition } from './bosses'
import { KNIGHT_TWO_ACT_POOL, setVigilKnightPoolOverride } from './econ'

// 騎士を3幕から2幕へ作り替える (2026-10-09 比較版 → 2026-10-10 ユーザー採用「騎士の2幕 採る」で既定 = 2幕・DEV ?knightActs=3 で旧の3幕)。
//   game.ts の DEV の箱の中だけが URL を読んで setKnightActs を呼ぶ (配布版は常に既定の2幕)。
//   ユーザー原文「騎士は今3幕のボスになっているが2幕のボスに変更で良い」
//   「幕2の技も幕1に移動していいし、幕3の技も幕2に移動して良い。いい感じのバランスにしてほしくて、難易度としては幕1＜幕2になるように
//    調整してほしい。特に連撃が長いものは後半へ」
//   指定なし (配布版) = 2幕。3幕へ戻すのは DEV の ?knightActs=3 だけ。定義の元 (bosses.ts) は書き換えず、getBossDefinition の度にこの関数が2幕版を返す (戴冠獣の hound_kit と同じ形)。
//
// 振り分け (技は1つも削らない):
//   幕1 = 単発の突き・単発の払い・壁ぎわ/マンネリの突進 (元の幕1)
//       + 柄の押し返し・切り下がり (近い時の技)・近くの膠着の上限 + 払い→払い→突き (3連・危ない拍が最後)・払い→石突 (2連) (元の幕2)
//   幕2 = 払い→突き→払い (3連・危ない拍が真ん中)・五連 (混ぜ)・五連の払い (元の幕3) ＋ 幕1の全部。単発は 0.2 倍 (連が主体・10-02 の幕3の決定をそのまま)
//   最後の幕の攻撃の回転 (finalRoomTempoMul 0.82)・弾きの体幹 0.8 倍 (finalRoomPostureMult) は「最後の幕」に掛かるので、自動で幕2へ移る。
// 体力・体幹の量は econ.ts の KNIGHT_TWO_ACT_POOL (econ 側で後から合わせる)。
export type KnightActs = 2 | 3
let acts: KnightActs = 2

export const KNIGHT_TWO_ACT_UNLOCK: Readonly<Record<string, number>> = {
  'knight-proclamation': 0,
  'knight-ward-sweep': 0,
  'knight-threshold-cross': 0,
  'knight-threshold-shove': 0,
  'knight-boundary-sweep': 0,
  'knight-sweep-punish': 0,
  'knight-feint-thrust': 1,
  'knight-boundary-five': 1,
  'knight-five-sweep': 1,
}

export function parseKnightActs(raw: string | null | undefined): KnightActs {
  return raw === '3' ? 3 : 2
}
export function setKnightActs(v: KnightActs): void {
  acts = v
  setVigilKnightPoolOverride(v === 2 ? KNIGHT_TWO_ACT_POOL : null)
}
export function knightActs(): KnightActs { return acts }

// 既定の 2幕の体力・体幹をこの読み込み時に置く (3幕へ戻す時だけ setKnightActs(3) が外す)。
setVigilKnightPoolOverride(KNIGHT_TWO_ACT_POOL)

export function resolveKnightActs(def: BossDefinition): BossDefinition {
  if (def.id !== 'vigil-knight' || acts === 3) return def
  return {
    ...def,
    roomCount: 2,
    roomHpFractions: KNIGHT_TWO_ACT_POOL.roomHpFractions,
    strings: def.strings?.map(s => {
      const at = KNIGHT_TWO_ACT_UNLOCK[s.id]
      if (at === undefined) return s
      const { unlockAtExecutes: _old, ...rest } = s
      return at > 0 ? { ...rest, unlockAtExecutes: at } : rest
    }),
    // DEV の単技 (?soloAttack) と連が無い時の控えの並び。石突は幕1から (払い→石突が幕1にあるため)。
    unlockByExecutes: [{ atExecutes: 0, ids: ['lanceThrust', 'lanceSweep', 'lanceButt'] }],
  }
}
